import React from 'react'
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"
import styled from 'styled-components'

import "./layout.css"
import "./typographyCss.css"
import Header from "./header"
import Image from './image'

const HeroLayout = styled.div`
  position: relative;
  height: 100vh;
  
  &::after {
    z-index: -1;
    content: "";
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background-color: rgba(0,0,0,0.2);
  }

  .gatsby-image-wrapper {
    z-index: -2;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    max-height: 100%;
    max-width: 100%;
    height: 100%;
  }

  & * {
    color: white;
  }

  img {
    object-fit: cover;
  }
`

const HeaderWrapper = styled.div`
  position: fixed;
  top: 0;
  width: 100%;

  header {
    background: transparent;
    transition: background-color ease-out 0.3s;
  }

  header:hover {
    background-color: rgba(20,10,3,0.8);
  }
`

const ChildrenWrapper = styled.div`
  color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  text-align: center;
  padding: 1rem;
`

const Footer = styled.footer`
  position: fixed;
  bottom: 0;
  width: 100%;
  min-width: 300px;
  font-size: 0.9em;
  padding: 0.7rem 1rem;
  background-color: transparent;
  text-align: center;
`


const Hero = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleHeaderQuery {
        site {
          siteMetadata {
            title
            author
          }
        }
      }
    `}
    render={data => (
      <HeroLayout>
        <Image imageQuery="headerImage" />
        <HeaderWrapper>
          <Header siteTitle={data.site.siteMetadata.title} />
        </HeaderWrapper>
        <ChildrenWrapper>
          {children}
        </ChildrenWrapper>
        <Footer>
          {data.site.siteMetadata.author} © {new Date().getFullYear()}, 
          Built&nbsp;with&nbsp;
          <a href="https://www.gatsbyjs.org">Gatsby</a>
        </Footer>
      </HeroLayout>
    )}
    />
)

Hero.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Hero